import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Production line'

  }
];

@Component({
  selector: 'page-production-line',
  templateUrl: './production-line.html',
  styleUrls: ['./production-line.scss']
})

export class PageProductionLine implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = false;
  key: any = "";
  lines = [];
  parts = [];
  productIpo: String;
  productDom: String;
  picture:String;
  //autoincreate
  filtered: any;
  ctrl: FormControl;
  ptControl: String;
  fControl: String;
  mControl: String;
  eControl: String;
  filteredIpo: any;
  filteredDom: any;
  filteredComp: any;
  ctrlIpo: FormControl;
  ctrlDom: FormControl;
  ctrlComp: FormControl;

  items = [];


  products = [];
  //form
  form: FormGroup; selectedCtrl = new FormControl();
  processs = []; arr_process = [];
  selected=[];
  code: string; name: string; ct: string; detail: string; id: string;
  ckedit: boolean = false;
  //upload
  fileupload: string;
  //data table
  data: any;
  rows = []; temp = [];
  //upload file
  imageSrc: any;
  tm_id: String;
  urlApi = environment.url + "/api/uploadToserver.php";
  Name: string;
  myFile: File; /* property of File type */
  controlCheck: boolean = false;
  checkSheetF: boolean = false;
  checkSheetM: boolean = false;
  checkSheetE: boolean = false;
  activeCheck: any = 0;
  //dialog
  dialogRefWarning: MdDialogRef<WarningLineDialog>;
  dialogRef: MdDialogRef<lineDialog>;
  setId: any;
  picUrl: String = environment.sysPath;
  sysPathPrint: String = environment.sysPath + "/api/line-list-print.php";
  sysPathExport: String = environment.sysPath + "/api/line-list-export.php";
  sysPath:String=environment.sysPath;
  ckUrl:boolean=false;

  dropdownListProcess = [];
  selectedItemsProcess = [];
  dropdownListTrade = [];
  selectedItemsTrade = [];
  dropdownSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "col-md-12"
  };

  print="";

  constructor(private fb: FormBuilder, private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
    this.getSearchLine();
    this.getProcess();
    this.getStartData();
    this.getProduct();
    this.getPart();

    //this.setId = this.intervalGetData();
    // //console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }

  openPrint(){

    for(let i=0;i<this.selected.length;i++){
          
    ////console.log('----select---',this.selected[i]['tpr_id'],this.selected);
              if(this.selected[i]['tpr_id']!="undefined"){
                this.print+="&print[]="+this.selected[i]['tpr_id'];
      }    
    }
    
    let popupWinindow
    popupWinindow = window.open( environment.url+'/api/print-line.php?'+this.print, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
    this.selected = [];
    this.print="";
    
    }

  openQrDialog(){

    this.httpservice.fetchget('print-line-qr.php?id='+this.id,data=>{
      const printContent = document.getElementById("print-section");
      const WindowPrt = window.open('', '', 'left=0,top=0,width=700,height=400,toolbar=0,scrollbars=0,status=0');
      WindowPrt.document.write(printContent.innerHTML);
      WindowPrt.document.write('<title>Operator QR-Code</title>');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.css">');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.min.css">');
      WindowPrt.document.close();
      WindowPrt.onload = function() {
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
      };
    });

}//end print


  onItemSelect(item: any) {
    //console.log(item);
    console.log('process',this.selectedItemsProcess);

    //this.selectedItems.push(item);
  }
  onItemSelectTrade(item: any) {
    //console.log(item);
    console.log('trade',this.selectedItemsTrade);

    //this.selectedItems.push(item);
  }
  OnItemDeSelect(item: any) {
    //console.log(item);
    //console.log(this.selectedItemsProcess);
  }
  onSelectAll(items: any) {
    //console.log(items);
  }
  onDeSelectAll(items: any) {
    //console.log(items);
  }

  intervalGetData() {

    return setInterval(() => {
      if (this.setId.runCount > 5) {
        clearInterval(this.setId);
      }
      this.getStartData();
      //console.log('------this.setId------', this.setId);
    }, 1000);

  }

  getActiveStatus($event) {
    if ($event.checked == true) {
      this.activeCheck = 1;
    } else {
      this.activeCheck = 0
    }
    //console.log('control point', this.activeCheck);

  }

  getStartData() {

    this.httpservice.fetchget('getJSON_line.php?all=1', (data) => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      //console.log('------this.machine------', this.key, data, this.rows);
    });
  }

  getIpo(id: String) {
    this.productIpo = id;
  }
  getDom(id: String) {
    this.productDom = id;

  }
  getComp(id: String) {
    this.tm_id = id;
  }
  getPart() {
    this.httpservice.fetchget('getJSON_material.php?', (data) => {
      this.parts = data;
    });
    //IPO
    this.ctrlComp = new FormControl();
    this.filteredComp = this.ctrlComp.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        //console.log('------val------', this.key);
        return val ? this.parts.filter((s) => new RegExp(val, 'gi').test(s.tm_part_no)) : this.parts;
      });
  }

  getProduct() {
    this.httpservice.fetchget('getJSON_product.php?', (data) => {
      this.products = data;
      console.log('data',data);
      for (let i = 0; i < data.length; i++) {
        this.dropdownListTrade.push({ "id": data[i].tp_id, "itemName": data[i].tp_part_no });
      }

    });
    //IPO
    this.ctrlIpo = new FormControl();
    this.filteredIpo = this.ctrlIpo.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        //console.log('------val------', this.key);
        return val ? this.products.filter((s) => new RegExp(val, 'gi').test(s.tp_part_no)) : this.products;
      });
    //dom
    this.ctrlDom = new FormControl();
    this.filteredDom = this.ctrlDom.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        //console.log('------val------', this.key);
        return val ? this.products.filter((s) => new RegExp(val, 'gi').test(s.tp_part_no)) : this.products;
      });
  }
  getProcess() {
    this.httpservice.fetchget('getJSON_process.php?', (data) => {
      this.processs = data;

      for (let i = 0; i < data.length; i++) {
        this.dropdownListProcess.push({ "id": data[i].tpn_id, "itemName": data[i].tpn_name });
      }

      ////console.log('process',this.processs);
    });
  }

  getSearchLine() {
    this.httpservice.fetchget('getJSON_line_name.php?', (line) => {
      this.lines = line.map(function (val) {
        return [val.tpr_name];
      });
      //console.log('------this.machine------', this.lines);
    });

    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        //console.log('------val------', this.key);
        return val ? this.lines.filter((s) => new RegExp(val, 'gi').test(s)) : this.lines;
      });
  }

  delete(id: string) {
    let val = { id: id }
    this.httpservice.fetchpost('deleteLine.php', val, (cb) => { });
    this.getStartData();
    this.cancelEdit();
  }
  onSelect({ selected }) {
    //console.log('Select Event', this.selected);
   
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  setedit(id: string) {
    this.id = id;
    this.ckedit = true;
    this.ckUrl = true;
    this.selected = [];
    this.productDom = '',
      this.productIpo = '';
    this.tm_id = '';
    //this.cancelEdit();
    this.httpservice.fetchget('getJSON_line.php?id=' + id, (process) => {
      this.form.controls.code.setValue(process[0].tpr_code);
      this.form.controls.shortname.setValue(process[0].tpr_short_name);
      this.form.controls.name.setValue(process[0].tpr_name);
      this.form.controls.ct.setValue(process[0].tpr_ct);
      this.form.controls.detail.setValue(process[0].tpr_detail);
      this.ctrlIpo.setValue(process[0].tb4_product_ipo_show);
      this.ctrlDom.setValue(process[0].tb4_product_dom_show);
      this.productIpo = process[0].tb4_product_ipo;
      this.productDom = process[0].tb4_product_dom;
      this.tm_id = process[0].tb14_material_tm_id;
      this.ctrlComp.setValue(process[0].tm_part_no);

      this.activeCheck = Number(process[0].tpr_status);

      if (process[0].tpr_pt_process == "1") {
        this.controlCheck = true;
        this.ptControl = "1";
      } else {
        this.controlCheck = false;
        this.ptControl = "0";
      }

      if (process[0].tpr_check_sheet_f == "1") {
        this.checkSheetF = true;
        this.fControl = "1";
      } else {
        this.checkSheetF = false;
        this.fControl = "0";
      }

      if (process[0].tpr_check_sheet_m == "1") {
        this.checkSheetM = true;
        this.mControl = "1";
      } else {
        this.checkSheetM = false;
        this.mControl = "0";
      }

      if (process[0].tpr_check_sheet_e == "1") {
        this.checkSheetE = true;
        this.eControl = "1";
      } else {
        this.checkSheetE = false;
        this.eControl = "0";
      }

      //this.user_selected.setValue("77");
      //this.selected=process[0].process;
      this.selectedItemsProcess = process[0].process_mul;
      this.selectedItemsTrade = process[0].product_mul;
      //console.log('setEdit', this.productDom, this.productIpo, this.tm_id, process[0].tpr_pt_process, this.controlCheck);
    });


  }

  edit() {
    //console.log('edit', this.ctrlIpo.value);
    if (this.ctrlIpo.value == null || this.ctrlIpo.value == "") {
      this.productIpo = "";
    }

    if (this.ctrlDom.value == null || this.ctrlDom.value == "") {
      this.productDom = "";
    }



    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }

    this.ckedit = false;

    this.data = {
      id: this.id,
      code: this.form.controls.code.value,
      name: this.form.controls.name.value,
      detail: this.form.controls.detail.value,
      shortname: this.form.controls.shortname.value,
      ct: this.form.controls.ct.value,
      filename: this.fileupload,
      //process:this.selectedCtrl.value,
      process: this.selectedItemsProcess,
      product:this.selectedItemsTrade,
      activeCheck: this.activeCheck,
      productIpo: this.productIpo,
      productDom: this.productDom,
      ptControl: this.ptControl,
      eControl: this.eControl,
      mControl: this.mControl,
      fControl: this.fControl,
      tm_id: this.tm_id
    }
    // insert data
    this.httpservice.fetchpost('editDataLine.php', this.data, (cb) => { });
    this.getStartData();
    //upload image
    if (this.myFile != null) {
      this.uploadPhoto(this.myFile);
    }
    this.cancelEdit();


  }

  cancelEdit() {
    this.ckedit = false;
    this.ckUrl = false;
    this.controlCheck = false;
    this.checkSheetF = false;
    this.checkSheetE = false;
    this.checkSheetM = false;
    this.selectedCtrl.reset();
    this.selected = [];
    this.form.reset();

    this.ctrlDom.reset();
    this.ctrlIpo.reset();
    this.ctrlComp.reset();


  }

  getInfo(val: any, _event: any, index: any) {

    if (_event.isUserInput) {
      if (_event.source.selected == true) {
        this.arr_process.push(val);
        ////console.log('true',_event.source.selected,_event,this.user_selected.value);
      } else {
        this.arr_process.splice(index, 1);
        /////console.log('false',_event.source.selected,_event,this.user_selected.value);
      }
    }
  }



  save() {
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }


    this.data = {
      code: this.form.controls.code.value,
      name: this.form.controls.name.value,
      detail: this.form.controls.detail.value,
      shortname: this.form.controls.shortname.value,
      ct: this.form.controls.ct.value,
      filename: this.fileupload,
      //process:this.arr_process,
      process: this.selectedItemsProcess,
      product:this.selectedItemsTrade,
      productIpo: this.productIpo,
      productDom: this.productDom,
      ptControl: this.ptControl,
      eControl: this.eControl,
      mControl: this.mControl,
      fControl: this.fControl,
      activeCheck: this.activeCheck,
      tm_id: this.tm_id
    }
    // insert data
    this.httpservice.fetchpost('insertDataLine.php', this.data, (cb) => { });
    this.getStartData();
    //upload image
    if (this.myFile != null) {
      this.uploadPhoto(this.myFile);
    }

    //this.form.reset();
    // this.selectedCtrl.reset();
    //this.ctrlDom.reset();
    //this.ctrlIpo.reset();
    this.cancelEdit();

  }

  search() {
    clearInterval(this.setId);
    this.httpservice.fetchget('getJSON_line.php?key=' + this.key, (line) => {
      this.rows = line;
    });
    this.ctrl.reset();
    this.key = "";
  }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      ct: [null, Validators.compose([Validators.required])],
      shortname: [null, Validators.compose([Validators.required])],
      detail: [null, Validators.compose([Validators.required])],
      inputFile: [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event): void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function (e) {
      _self.imageSrc = reader.result;
      //console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
    //this.uploadPhoto(event.target.files[0]);
    //console.log('File name : ', this.myFile.name);
  }

  updateFilter_short_name(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.tpr_short_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_line_name(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.tpr_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  getControlStatus($event) {
    if ($event.checked == true) {
      this.ptControl = "1";
    } else {
      this.ptControl = "0";
    }
    //console.log('control point', this.ptControl);

  }

  getCheckSheetF($event) {
    if ($event.checked == true) {
      this.fControl = "1";
    } else {
      this.fControl = "0";
    }
    //console.log('control point', this.fControl);
  }

  getCheckSheetM($event) {
    if ($event.checked == true) {
      this.mControl = "1";
    } else {
      this.mControl = "0";
    }
    //console.log('control point', this.mControl);
  }

  getCheckSheetE($event) {
    if ($event.checked == true) {
      this.eControl = "1";
    } else {
      this.eControl = "0";
    }
    //console.log('control point', this.eControl);
  }


  uploadPhoto(file: File) {
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }

  openDeleteDialog(id: string) {

    let dialogRef = this.dialog.open(lineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
        this.delete(id);
        //console.log('---result---', result, id);
        // alert('postString');
      } else {
        //console.log('---result---', result);
        // alert('cancel');
      }
    });
  }
  openEditDialog() {
    let dialogRef = this.dialog.open(lineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
        if (this.form.controls.name.value != "" && this.form.controls.name.value != "undefined") {
          this.edit();
        } else {
          this.warningDialog('Please fill in prodcution line name');
        }

        // //console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
        // alert('postString');
      } else {
        //console.log('---result---', result);
        // alert('cancel');
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(lineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
        if (this.form.controls.name.value != "" && this.form.controls.name.value != "undefined") {
          this.save();
        } else {
          this.warningDialog('Please fill in prodcution line name');
        }

        //console.log('---result---', result);
        // alert('postString');
      } else {
        //console.log('---result---', result);
        // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningLineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        //console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'line-dialog',
  templateUrl: 'dialog.html',
})
export class lineDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<lineDialog>) { }
}

//warning
@Component({
  selector: 'warning-process-dialog',
  templateUrl: 'warning.html',
})
export class WarningLineDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningLineDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/production-line/production-line.ts